'use strict';

var Classnames = require('classnames');
var LinkedStateMixin = require('react-addons-linked-state-mixin');
var React = require('react');

var isNode = typeof document === 'undefined';
if (!isNode) {
    require('./finance.scss');
}

var Forms = require('../../forms');

function NumberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

var Results = React.createClass({
    getInitialState: function() {
        return {
            ranges: []
        };
    },
    componentWillReceiveProps: function(nextProps) {
        var terms = [ 24, 36, 48, 60 ];
        var mults = [[ 0.0448, 0.0471 ],
                     [ 0.0309, 0.0332 ],
                     [ 0.0239, 0.0263 ],
                     [ 0.0198, 0.0222 ]];
        if (!nextProps.input) {
            var input = 0;
        } else {
            var input = parseInt(nextProps.input.replace(/[,$]/g,''));
            if (isNaN(input)) {
                input = 0;
                if (!this.props.error.value) {
                    this.props.error.requestChange(true);
                }
            } else if (this.props.error.value) {
                this.props.error.requestChange(false);
            }
        }
        var ranges = mults.map((m,ix) => {
            return {
                term: terms[ix],
                min: NumberWithCommas(Math.round(input * m[0])),
                max: NumberWithCommas(Math.round(input * m[1])),
            };
        });
        this.setState({
            ranges: ranges
        });
    },
    render: function() {
        return (
            <div className='finance-results'>
                {this.state.ranges.map(r => {
                    return (
                        <div className='finance-results-row' key={r.term}>
                            <div className='finance-results-row-label'>
                                {r.term} MONTHS
                            </div>
                            <div className='finance-results-row-cell'>
                                <h3>FROM</h3>
                                <br />
                                <h4>{'$' + r.min}</h4>
                            </div>
                            <div className='finance-results-row-cell'>
                                <h3>TO</h3>
                                <br />
                                <h4>{'$' + r.max}</h4>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
});

var Finance = React.createClass({
    mixins: [ LinkedStateMixin ],

    getInitialState: function() {
        return {
            input: null,
            error: false,
        };
    },
    render: function() {
        var inputClasses = Classnames({
            'finance-input': true,
            'finance-input-error': this.state.error,
        });
        return (
            <div className='pg-content pg-content-sidebar finance'>
                <div className='finance-mobile-inset'>
                    <h2>FINANCIAL</h2>
                    <h1>CALCULATOR</h1>
                    <p>
                        You can enjoy new furniture with our leasing option. Make monthly payments instead of a cash
                        outlay up front. To estimate lease payments: simply enter your total Furniture Budget below.
                        Your monthly estimated payments will generate automatically. (To get a realistic furniture
                        budget for your office, check out our <a href='/budget-your-office'>Budget Your Office</a> tool).
                    </p>
                    <div className={inputClasses}>
                        <label>
                            FURNITURE COST
                            <span className='finance-dollar'>$</span>
                        </label>
                        <input type='text' valueLink={this.linkState('input')} />
                    </div>
                </div>
                <Results input={this.state.input} error={this.linkState('error')} />
            </div>
        );
    },
});

module.exports = Finance;



// WEBPACK FOOTER //
// ./src/pages/content/finance.jsx